var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"post"}},_vm._l((_vm.allPosts),function(post){return _c('div',{key:post.id,staticClass:"currentPost"},[_c('h2',[_vm._v(_vm._s(post.title))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }